/* eslint-disable @typescript-eslint/no-explicit-any */
import {Injectable,} from '@angular/core';

import { ActivatedRoute, Router } from "@angular/router";
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders, } from '@angular/common/http';
import { WindowService } from './services/window.service';
import { LocalStorageService } from './services/localstorage.service';

@Injectable(
    {
        providedIn: 'root'
      }
)
export class AppService {
    user_info: any;
    access_token: any;
    public base_url: any;
    public site_url!: string;
    public api_base_url!: string;
    public headers: any;
    // public requestoptions: HttpHeaders;
    public res: any;
    public isUserLoggedIn = false;
    public isLoginPage = false;
    loginSubject: Subject<any> = new Subject<any>();
    summarySubject: Subject<any> = new Subject<any>();
    media_base_url = '';
    token: any;
    public user_location: any;
    isOnMobilePlatform: any;
    _ct_url = '';
    share_url!: string;
    isProduction = false;
    cart_data: any = { status: true, slug_name: '', product_count: 0 };
    product_count: any;
    locationPop = false;
    isUpdateLocation = false;
    cart_status_data: any;
    visibleSideProfile!: boolean;
    displayNavSlider = false;
    ws_path!: string;
    isBrandLiveOffers = false;
    compareOffers:any;
    mobile!: string;
    subscribeUrl:any;
    isDisplayLogin=false;
    isDisplayBudget=false;
    next_task_after:any;
    is_footer=true;
    edealerURl: any="";
    suppartemail='support@afterbricks.com';
    supportmobile="+91 8800909063";
    infomail="info@afterbricks.com"
    price_help_text="(Indicative discounts only)";
    price_help_text_one="(Indicative price only)";
    private loggedIn = new BehaviorSubject<boolean>(false);
    public isLoggedInSubject = new BehaviorSubject<boolean>(false);
    constructor(private window: WindowService,private http: HttpClient, public router: Router, private _actRouter: ActivatedRoute,private localStorageService: LocalStorageService) {
        // if(isPlatformBrowser(platformId)){
            const win = this.window.nativeWindow;
if(win){
    if (win.innerWidth <= 600) {
        this.isOnMobilePlatform = true;
    } else {
        this.isOnMobilePlatform = false;
    }
}
        this.isProduction = true;

        // this.mobile_site_url = 'https://m.afterbricks.com';
        // **************** Local server api ***************************/
        // this.share_url = 'https://localhost:4200/';
        // this.base_url = "http://127.0.0.1:8000";
        // this.api_base_url = "http://127.0.0.1:8000/api/";
        // this.ws_path = 'ws://127.0.0.1:8000/ws/jwc/';
        // this.subscribeUrl = 'http://localhost:4700/';
        // this.site_url = 'http://localhost:4200';
        // this.edealerURl = "http://localhost:5600/"
        if (!this.isProduction) {
            //     //  **************** Testing server api ***************************/
            this.share_url = 'https://acpl2024.afterbricks.in/';
            this.base_url = 'https://testapiv3.afterbricks.co';
            this.api_base_url = 'https://testapiv3.afterbricks.co/api/';
            this.ws_path = 'wss://testapiv3.afterbricks.co/ws/jwc/';
            this.subscribeUrl = 'https://testpros.afterbricks.co/';
            this.site_url = 'https://acpl2024.afterbricks.in';
            this.edealerURl = "https://testing.edealer.in/" 
            // this.websocketurl = ""
        } else {
            this.subscribeUrl = 'https://pro.afterbricks.com';
            this.share_url = "https://www.afterbricks.com/"
            this.base_url = "https://testapi.afterbricks.co";
            this.api_base_url = "https://testapi.afterbricks.co/api/";
            this.ws_path = 'wss://testapi.afterbricks.co/ws/jwc/';
            this.edealerURl = "https://edealer.in/"
        
            this.site_url = 'https://www.afterbricks.com';
        }

        if (this.localStorageService.getItem('user_info') || "") {
            this.isUserLoggedIn = true;
            this.user_info = JSON.parse(this.localStorageService.getItem('user_info') || '{}');
            this.access_token = this.user_info.token.access_token;
        }

        this.loginSubject.subscribe(() => {
            if (this.localStorageService.getItem('user_info') || "") {
                this.isUserLoggedIn = true;
                this.user_info = JSON.parse(this.localStorageService.getItem('user_info') || '{}');
                this.access_token = this.user_info.token.access_token;
            }
        })

        if (this.router.url.split('/')[1] == 'login') {
            this.isLoginPage = true;
        }
        if (this.router.url.split('/')[1] == "login" || this.router.url.split('/')[1].split('?')[0] == "login") {
            this.isLoginPage = true;
        } else {
            this.isLoginPage = false;
            // this.localStorageService.removeItem('otp_detail')
        }
        try {
            this.user_location = JSON.parse(this.localStorageService.getItem('user_location') || '');

        } catch {
            this.user_location = undefined
        }
    // }
    }

get isLoggedIn$(): Observable<boolean> {
    return this.isLoggedInSubject.asObservable();
    }

      // Check if the user is logged in
  isLoggedIn(): boolean {
    return this.isLoggedInSubject.value;
  }

  // Simulate login and notify observers
  login(): void {
    this.isLoggedInSubject.next(true);
  }
 // Call this method upon successful login
 loginSuccess() {
    console.log("befor Login =>",this.loggedIn)
    this.loggedIn.next(true);
    console.log("after Login =>",this.loggedIn)
  }

  // Expose login state as an observable
  get isLoggedIn1() {
    return this.loggedIn.asObservable();
  }
    getHttpOptions(isAuth: any) {
  
        if (isAuth) {
            const httpOptions = {
                headers: new HttpHeaders({
                    'Authorization': 'Bearer ' + this.access_token,
                })
            };
            return httpOptions;
        } else {
            const httpOptions = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                  
                })
            };
            return httpOptions;
        
    }

    }
    getMultipartHttpOptions(isAuth: any) {
        this.headers = new HttpHeaders();
        if (isAuth) {
            const HttpUploadOptions = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    //   'Authorization': 'Bearer ' + this.access_token
                })
            }
            return HttpUploadOptions
        } else {
            const HttpUploadOptions = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.access_token,
                    
                })
            }
            return HttpUploadOptions
        }
    }
    public getRequest(url: string, isAuth: boolean): Observable<any> {
        return this.http.get(url, this.getHttpOptions(isAuth));
    }

    public postRequest(url: string, data: any, isAuth: boolean): Observable<any> {
        return this.http.post(url, data, this.getHttpOptions(isAuth));
    }

    public putRequest(url: string, data: any, isAuth: boolean): Observable<any> {
        return this.http.put(url, data, this.getHttpOptions(isAuth))
    }
    public deleteRequest(url: string, isAuth: boolean): any {
        return this.http.delete(url, this.getHttpOptions(isAuth));
    }

    public postMultipartRequest(url: string, data: any, isAuth: boolean): Observable<any> {
        return this.http.request(url, data, this.getMultipartHttpOptions(isAuth));
    }


    // End request options
    public getRequestWithBasicAuth(url: string, data: any): any {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + data
            })
        };

        return this.http.get(url, httpOptions)
    }
    public postRequestResetPassword(url: string, data: any): any {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + data
            })
        };

        return this.http.get(url, httpOptions)
    }
    goToHome() {
        this.router.navigate(['crm/dashboard'])
    }

    
    onLoginPage(mobile?:any) {
        // if(isPlatformBrowser(this.platformId)){
        let paramsObject: any;
        this._actRouter.queryParamMap
            .subscribe((params:any) => {
                paramsObject = { ...params };
            } 
            );
        const redirectTo = {
            link: this.router.url.split('?')[0],
            queryParams: paramsObject.params
            // isProdetailPage:false
        }
        this.localStorageService.setItem('redirectTo', JSON.stringify(redirectTo));
        // this._router.navigate(['account/signin'])
        this.visibleSideProfile = false;
        this.displayNavSlider = false;
        this.router.navigate(['login'],{queryParams:{mobile:mobile}})
    // }
    }
    
    checkCart() {
        // if (this.isUserLoggedIn) {
        //     let project_id: Number;
        //     try {
        //         project_id = this.user_info.directSearch.projectInfo.id
        //     } catch { }
        //     let form_type = "search"
        //     const url = this.api_base_url + `user/check-cart/?project=` + project_id + `&form_type=` + form_type;
        //     this.getRequest(url, true)
        //         .subscribe((res: any) => {
        //             this.cart_data = res.data;
        //             this.product_count = res.data.product_count
        //         },
        //             (err: any) => {

        //             })
        // }
    }
   
}
